<template>
  <v-container min-width="100%">
    <div v-if="isRootBasePage">
      <span v-for="(breadcrumb, index) in breadcrumbs" :key="index">
        <a style="color: green" href="#" @click.prevent="navigateTo(index)">{{ breadcrumb.text }}</a>
        <span v-if="index < breadcrumbs.length - 1"> / </span>
      </span>
    </div>
    <div v-if="breadcrumbs && breadcrumbs.length === 1">
      <slot :openSubPage="openSubPage"></slot>
    </div>
    <component v-if="sitedatas && sitedatas.length > 0" :is="currentPage" :siteData="sitedatas[sitedatas.length - 1]"></component>
  </v-container>
</template>

<script lang="ts" setup>
import { ref, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue';
//import { useRouter, useRoute } from 'vue-router';
// const router = useRouter();
// const route = useRoute();
import { } from "@/NavigationHelper";

const isBasePage = true;
const isRootBasePage = ref(true);
const currentPage = ref('HomePage');
const breadcrumbs = ref([{ text: 'Home', disabled: false, href: '#' }]);

const sitedatas = [null];
const callOnLeaves: ((() => void) | undefined)[] = [];

let parentBasePage = searchForParentBasePage();

function openSubPage(pageName: string, breadcrumbText: string, siteData: any = undefined, callOnLeave: CallOnLeaveCallback | undefined = undefined) {
  if (parentBasePage) {
    const parentOpenSubPage = (<any>parentBasePage).setupState.openSubPage;
    if (parentOpenSubPage) {
      parentOpenSubPage(pageName, breadcrumbText, siteData, callOnLeave);
      return;
    }
  }

  currentPage.value = pageName;
  breadcrumbs.value.push({ text: breadcrumbText, disabled: false, href: '#' });
  window.history.pushState({}, '', `#${breadcrumbText}`);
  sitedatas.push(siteData);
  callOnLeaves.push(callOnLeave);
}

function goBack() {
  if (breadcrumbs.value.length > 1) {
    callCurrentOnLeaveCallback();
    breadcrumbs.value.pop();
    currentPage.value = breadcrumbs.value[breadcrumbs.value.length - 1].text;
  }
}

function handlePopState() {
  goBack();
}

function navigateTo(index: number) {
  while (breadcrumbs.value.length > index + 1) {
    breadcrumbs.value.pop();
  }
  currentPage.value = breadcrumbs.value[index].text;
}

// const vueInstance = getCurrentInstance();
onMounted(() => {
  window.addEventListener('popstate', handlePopState);
});

onBeforeUnmount(() => {
  window.removeEventListener('popstate', handlePopState);
});

// Example usage
// openSubPage('SubPageComponent', 'Sub Page');

async function callCurrentOnLeaveCallback() {
  try {
    const callOnLeave = callOnLeaves[breadcrumbs.value.length - 1];

    if (callOnLeave) callOnLeave();
  } catch (e) { console.error(e); }
}

function searchForParentBasePage() {
  let i = 0;
  const vueInstance = getCurrentInstance();
  let parentBasePage = vueInstance?.parent;
  if (!parentBasePage) {
    return;
  }
  do {
    if ((<any>parentBasePage).setupState.isBasePage) {
      isRootBasePage.value = false;
      break;
    }
    parentBasePage = parentBasePage?.parent;
    i++;
  } while (parentBasePage && i < 15);
  return parentBasePage;
}
</script>
<script lang="ts">
export type CallOnLeaveCallback = () => Promise<boolean> | void;
export type OpenSubPageFunction = (pageName: string, breadcrumbText: string, siteData?: any, callOnLeaveCallback?: CallOnLeaveCallback) => void;
</script>